import { useState } from 'react';
import { Code, ExternalLink, X } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export default function DemoBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const { t } = useLanguage();

  if (!isVisible) return null;

  return (
    <div className="bg-linear-to-r from-indigo-600 via-purple-600 to-indigo-600 text-white relative">
      <div className="max-w-7xl mx-auto px-4 py-2.5 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center gap-2 sm:gap-4 text-sm">
          <Code className="w-5 h-5 shrink-0 hidden sm:block" />
          <p className="text-center">
            <span className="font-semibold">{t('demo.title')}</span>
            <span className="hidden sm:inline"> — {t('demo.description')}</span>
            <span className="sm:hidden"> — {t('demo.descriptionShort')}</span>
          </p>
          <a
            href="https://fackelmeyer.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full text-xs font-medium transition-colors whitespace-nowrap"
          >
            fackelmeyer.com
            <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
      <button
        onClick={() => setIsVisible(false)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 hover:bg-white/20 rounded-full transition-colors"
        aria-label={t('demo.close')}
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
